/** @format */

import sensorCriticalImg from 'pages/Home/Main/CategoryNew/images/sensor-critical.svg';
import sensorLowImg from 'pages/Home/Main/CategoryNew/images/sensor-low.svg';
import sensorRegularImg from 'pages/Home/Main/CategoryNew/images/sensor-regular.svg';

import {filterSensorGroups} from 'helpers/checkHelpers';

import {SensorGroupsFromQuery} from 'pages/Home/Main/Project/types/common';

import {SensorCriteriaProps, ValidCheck} from '../model';
import {getTotalAndTotalNew} from './getTotalAndTotalNew';

export interface CategoriesDataInterface {
  validChecks: ValidCheck[];
  sensorGroups: SensorGroupsFromQuery;
  descriptions: {
    critical: string;
    regular: string;
    low: string;
  };
}

const getCategoriesData = ({
  validChecks,
  descriptions,
  sensorGroups,
}: CategoriesDataInterface): SensorCriteriaProps[] => {
  const {red: allRed, yellow: allYellow, gray: allGray} = sensorGroups;

  const red = filterSensorGroups(validChecks, allRed);
  const yellow = filterSensorGroups(validChecks, allYellow);
  const gray = filterSensorGroups(validChecks, allGray);

  const isColorGroupsEmpty = !red.length && !yellow.length && !gray.length;

  if (isColorGroupsEmpty) {
    return [];
  }

  const result: SensorCriteriaProps[] = [];

  if (red.length) {
    const {totalNew, total} = getTotalAndTotalNew(validChecks, red);

    result.push({
      description: descriptions.critical,
      title: 'Критичные',
      icon: sensorCriticalImg,
      totalNew,
      total,
      variant: 'red',
      sensors: red.length,
      name: 'critical',
    });
  }

  if (yellow.length) {
    const {totalNew, total} = getTotalAndTotalNew(validChecks, yellow);

    result.push({
      description: descriptions.regular,
      title: 'Обычные',
      icon: sensorRegularImg,
      totalNew,
      total,
      variant: 'yellow',
      sensors: yellow.length,
      name: 'normal',
    });
  }

  if (gray.length) {
    const {totalNew, total} = getTotalAndTotalNew(validChecks, gray);

    result.push({
      description: descriptions.low,
      title: 'Некритичные',
      icon: sensorLowImg,
      totalNew,
      total,
      variant: 'default',
      sensors: gray.length,
      name: 'low',
    });
  }

  return result;
};

export {getCategoriesData};
